<template>
  <div
    class="tabs-default__content__pane"
    :class="{'tabs--expanded': tabExpand(tabId)}"
  >
    <div class="tabs-default__content__pane--innercontent">
      <slot name="tabs-default__content__pane--innercontent" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'tabs-content',

  props: {
    tabId: {
      type: String,
      required: true
    },

    expanded: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    ...mapGetters([
      'tabExpand'
    ])
  }

}
</script>
